export interface Bonus {
  title: string
  description: string
  price: string
  image: string
}

export const bonuses: Bonus[] = [
  {
    title: 'Pacchetto Flashcard',
    description: '40 schede da ritagliare per ogni anno scolastico.',
    price: '25 €',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/6910a234-71d6-4266-bbe1-c8be0a3f334e.jpg',
  },
  {
    title: 'Kit Poster da Parete',
    description: '30 poster A3 a colori: tavola pitagorica, formule, teoremi e piano cartesiano.',
    price: '25 €',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/4328e714-6f0a-42b9-903a-710a4b07d160.jpg',
  },
  {
    title: 'Valutazione Pronta',
    description: 'Prove d’ingresso, verifiche e rubriche per tutti e 10 gli anni.',
    price: '20 €',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/fd635455-7605-4f2d-a367-5b48ab4834b3.jpg',
  },
  {
    title: 'Matematica Inclusiva',
    description: 'Schede adattate per alunni BES e DSA, ad alto contrasto e a passaggi guidati.',
    price: '15 €',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/7d714059-7cc5-4df8-a5f4-aad57b25f3c7.jpg',
  },
  {
    title: '60 Problemi Graduati',
    description: 'Problem solving dal facile alla sfida, con soluzioni commentate.',
    price: '15 €',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/d7f64518-4361-46ee-b5ad-0fc51873af69.jpg',
  },
]
